var exports = {
  "Nr": "VoiceActivityCard.module__card___ZWE5cU",
  "wu": "VoiceActivityCard.module__headerContextGroup___ZWE5cU",
  "U1": "VoiceActivityCard.module__headerRow___ZWE5cU",
  "LD": "VoiceActivityCard.module__headerLeft___ZWE5cU",
  "mB": "VoiceActivityCard.module__activityLabel___ZWE5cU",
  "l1": "VoiceActivityCard.module__streamingLabel___ZWE5cU",
  "kf": "VoiceActivityCard.module__contextButton___ZWE5cU",
  "kx": "VoiceActivityCard.module__contextChannelName___ZWE5cU",
  "fd": "VoiceActivityCard.module__contextIcon___ZWE5cU",
  "gE": "VoiceActivityCard.module__actionIcon___ZWE5cU",
  "o_": "VoiceActivityCard.module__contextGuildIcon___ZWE5cU",
  "pz": "VoiceActivityCard.module__contextChevron___ZWE5cU",
  "mr": "VoiceActivityCard.module__contextDmAvatar___ZWE5cU",
  "Nu": "VoiceActivityCard.module__participantsRow___ZWE5cU",
  "i1": "VoiceActivityCard.module__previewContainer___ZWE5cU",
  "n": "VoiceActivityCard.module__previewSubmitting___ZWE5cU",
  "FC": "VoiceActivityCard.module__previewHoverOverlay___ZWE5cU",
  "oz": "VoiceActivityCard.module__previewImage___ZWE5cU",
  "nZ": "VoiceActivityCard.module__previewFallback___ZWE5cU",
  "Mp": "VoiceActivityCard.module__previewHoverText___ZWE5cU",
  "$l": "VoiceActivityCard.module__actionRow___ZWE5cU",
  "hP": "VoiceActivityCard.module__actionButton___ZWE5cU",
};

module.exports = exports;
